import React from "react";
import { Container, Box } from "@mui/material";
import Authenticated from "../components/Layouts/Authenticated";
import { MATERIALS_DATABASE_URL } from "../constants";

const MaterialsDatabase: React.FC = () => {
  return (
    <Authenticated>
      <title>Materials Database - Materiom Commons</title>
      <Container
        maxWidth="xl"
        sx={{ py: 4, position: "relative", minHeight: "calc(100vh - 64px)" }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "calc(100vh - 128px)",
          }}
        >
          <iframe
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              border: "none",
            }}
            src={MATERIALS_DATABASE_URL}
            title="Materials Database"
          />
        </Box>
      </Container>
    </Authenticated>
  );
};

export default MaterialsDatabase;
